import React, { FC, memo } from "react";
import { createUseStyles, useTheme } from "react-jss";

import UnCheckedCircle from "Assets/images/unCheckedCircle.svg";
import CheckedCircle from "Assets/images/checkedCircle.svg";
import PersonalizationStars from "Assets/images/personalization_stars.svg";
import { areEqual } from "Utils/areEqual";
import styles from "./styles";

interface Props {
  destination: any;
  selected: boolean;
  changeHover: () => void;
  hover: boolean;
  click: () => void;
  stops: any[];
  openCount: number;
}

const SingleDestination: FC<Props> = memo(
  ({
    destination,
    selected = false,
    hover,
    changeHover,
    click,
    stops,
    openCount,
  }: Props) => {
    const useStyles = createUseStyles(styles);
    const theme = useTheme();
    const classes = useStyles({ theme, hover, openCount });
    const { title, thumbnail, isPersonalized } = destination;

    const visitedStopTitles = stops
      .filter((stop) => stop.state === "VISITED")
      .map((stop) => stop.title);

    return (
      <button
        type="button"
        className={`${classes.imgContainer} ${classes.button} ${
          selected ? classes.selected : ""
        }
      ${!selected ? classes.imgContainerUnselected : ""}      
      `}
        id={title}
        onMouseLeave={changeHover}
        onMouseEnter={changeHover}
        onFocus={changeHover}
        onBlur={changeHover}
        onClick={click}
        aria-label={
          isPersonalized ? `Personalized tour stop for you. ${title}` : title
        }
      >
        <div
          className={`${classes.image} ${hover ? classes.imgHover : ""}`}
          style={{
            backgroundImage: `url(${thumbnail})`,
          }}
        >
          <div
            className={`${classes.overlay} ${
              hover || selected ? classes.overlayHover : ""
            }`}
          />
        </div>
        {isPersonalized && (
          <div className={classes.badgeContainer}>
            <PersonalizationStars className={classes.badgeStars} />
          </div>
        )}
        <div className={classes.marker}>
          {selected || visitedStopTitles.includes(title) ? (
            <CheckedCircle />
          ) : (
            <UnCheckedCircle />
          )}
        </div>
        <div
          className={`${classes.text} ${
            hover || selected ? classes.textHover : ""
          }`}
        >
          {title}
        </div>
      </button>
    );
  },
  areEqual
);

export default SingleDestination;
try {
    // @ts-ignore
    SingleDestination.displayName = "SingleDestination";
    // @ts-ignore
    SingleDestination.__docgenInfo = { "description": "", "displayName": "SingleDestination", "props": { "destination": { "defaultValue": null, "description": "", "name": "destination", "required": true, "type": { "name": "any" } }, "selected": { "defaultValue": null, "description": "", "name": "selected", "required": true, "type": { "name": "boolean" } }, "changeHover": { "defaultValue": null, "description": "", "name": "changeHover", "required": true, "type": { "name": "() => void" } }, "hover": { "defaultValue": null, "description": "", "name": "hover", "required": true, "type": { "name": "boolean" } }, "click": { "defaultValue": null, "description": "", "name": "click", "required": true, "type": { "name": "() => void" } }, "stops": { "defaultValue": null, "description": "", "name": "stops", "required": true, "type": { "name": "any[]" } }, "openCount": { "defaultValue": null, "description": "", "name": "openCount", "required": true, "type": { "name": "number" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/SingleDestination/SingleDestination.tsx#SingleDestination"] = { docgenInfo: SingleDestination.__docgenInfo, name: "SingleDestination", path: "src/shared/components/SingleDestination/SingleDestination.tsx#SingleDestination" };
}
catch (__react_docgen_typescript_loader_error) { }